import { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';

import { WizardStepFooter } from '../components/wizard';
import pt from '../locales/pt';

/** Slot marker — OnboardingLayout overwrites with the live handleBack via cloneElement. */
const BACK_SLOT = () => {};

/**
 * Registers the sticky wizard footer on OnboardingLayout's WizardSkeleton.
 * Voltar is injected by OnboardingLayout with a live handleBack (avoids stale onBack
 * when Continuar navigates before the next step's footer effect runs).
 */
export function useOnboardingFooter({
  primaryLabel,
  primaryIcon,
  onPrimary,
  onSkip,
  skipLabel,
  loading = false,
  disabled = false,
}) {
  const { setFooter } = useOutletContext() || {};

  useEffect(() => {
    if (!setFooter) return undefined;

    setFooter(
      <WizardStepFooter
        primaryLabel={primaryLabel}
        primaryIcon={primaryIcon}
        onPrimary={onPrimary}
        onSkip={onSkip}
        skipLabel={skipLabel}
        onBack={BACK_SLOT}
        backLabel={pt.onboarding.common.back}
        loading={loading}
        disabled={disabled}
      />,
    );

    return () => setFooter(null);
  }, [setFooter, primaryLabel, primaryIcon, onPrimary, onSkip, skipLabel, loading, disabled]);
}
